import React from "react";
import { Outlet } from "react-router-dom";
import PropertiesList from "../../components/properties/properties.component";

import "./property.styles.scss";

const Property = () => {
  return (
    <div>
      <section className="our-listing bgc-f7 pb30-991 pt-120">
        <div className="container">
          <div className="row">
            <PropertiesList />
          </div>
        </div>
      </section>
      <Outlet />
    </div>
  );
};

export default Property;
